import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
@Injectable({
  providedIn: 'root'
})
export class OtrasGestionesProveedorService {

  constructor(private http: HttpClient) { }

//   getCBU(cuit){
//     return this.http.post(`${environment.urlApi}proveedor/aloginProveedor`, cuit)
//   }

//   getPeriodosPrestaciones(BenNroAse : String, Bennroord: String, DiscaExAnio: String, DiscaTramSec: String): any{
//     return this.http.get<any[]>(`${environment.urlApi}proveedor/getPeriodosPrestaciones?BenNroAse=${BenNroAse}&Bennroord=${Bennroord}&DiscaExAnio=${DiscaExAnio}&DiscaTramSec=${DiscaTramSec}`);
//   }

  sendFormConsultas(form: FormData): Observable<any> {
    return this.http.post(`${environment.urlApi}proveedor/sendFormConsultas`, form);
  }

  sendFormConsultaFacturacion(form: FormData): Observable<any> {
    return this.http.post(`${environment.urlApi}proveedor/sendFormConsultaFacturacion`, form);
  }
  
//   validateAfip(form: FormData): Observable<any> {
//     return this.http.post(`${environment.urlApi}proveedor/validateAfip`, form);
//   }

  getObrasSocialesProveedor(sessionID: string) {
    const headers = new HttpHeaders({
      'sessionid': sessionID
    });
    return this.http.get(`${environment.urlApi}proveedor/getObrasSocialesProveedor`, { headers });
  }
}